// @flow
import styled from 'styled-components';

export const DivLikeAButton = styled.div`
	cursor: pointer;
`;

export default DivLikeAButton;


// WEBPACK FOOTER //
// ./src/components/DivLikeAButton/index.js